import {MedicationForm} from '@/services/graphqlHooks';

// Priority-ordered patterns matching Polish pharmaceutical form names from the NFZ registry
const PHARMACEUTICAL_FORM_PATTERNS: Array<[RegExp, MedicationForm]> = [
  [/krople/i, MedicationForm.Drops],
  [/aerozol/i, MedicationForm.Aerosol],
  [/inhalac/i, MedicationForm.Inhalation],
  [/tabletk|tabletek|drażetk|pastylk|lamelk/i, MedicationForm.Tablet],
  [/kapsułk/i, MedicationForm.Capsule],
  [/transdermaln/i, MedicationForm.TransdermalSystem],
  [/plast/i, MedicationForm.Plaster],
  [
    /wstrzykiw|infuzj|wlewu|wlewów|hemodializ|hemofiltr|dializy/i,
    MedicationForm.Injection,
  ],
  [/syrop|doustny|doustne|doustna|w jamie ustnej/i, MedicationForm.Syrup],
  [
    /maść|krem|żel|pasta|puder|piank|szampon|sztyft|przezskórn|na skórę/i,
    MedicationForm.Ointment,
  ],
];

export function parsePharmaceuticalForm(
  pharmaceuticalForm: string | null | undefined
): MedicationForm | undefined {
  if (!pharmaceuticalForm) return undefined;

  for (const [pattern, form] of PHARMACEUTICAL_FORM_PATTERNS) {
    if (pattern.test(pharmaceuticalForm)) {
      return form;
    }
  }

  return MedicationForm.Other;
}
